import NamohLogo from './assets/images/NamohLogo.png'
import HPCLogo from './profile/components/img/HPC logo.png'

const clientConfig = {
  "nema": {
    "logo": "https://s3.ap-south-1.amazonaws.com/nemaai.com/logo.png",
    "footer": "Powered by NEMA AI",
    "website": "https://nemaai.com",
    "email": "support@nemaai.com",
    "phone": [
      "8744923572"
    ],
    "address": [
      {
        "city": "Kalkaji-Ext",
        "mapsURL": "https://maps.app.goo.gl/uwEVxbNYodLi8tp79"
      }
    ]
  },
  "samvedancdc@gmail.com": {
    "logo": "https://s3.ap-south-1.amazonaws.com/nemaai.com/samvedan_ahemdabad/Logo.png",
    "footer": "Powered by NEMA AI in partnership with Samvedan Child Development Centre",
    "website": "https://samvedancdc.com/",
    "email": "samvedancdc@gmail.com",
    "phone": [
      "7016208147",
      "9408500716"
    ],
    "address": [
      {
        "city": "Ahemdabad",
        "mapsURL": "https://maps.app.goo.gl/XfBpRLNch7R9wK9d9"
      },
      {
        "city": "Vadodara",
        "mapsURL": "https://maps.app.goo.gl/FYbbHMhwtpyYLTBt7"
      }
    ]
  },
  "cradlejpr@gmail.com": {
    "logo": "https://s3.ap-south-1.amazonaws.com/nemaai.com/craddle_jaipur/Logo.png",
    "footer": "Powered by NEMA AI in partnership with Cradle Children Hospital",
    "website": "https://cradlehospital.com/",
    "email": "cradlejpr@gmail.com",
    "phone": [
      "9116104308"
    ],
    "address": [
      {
        "city": "Jaipur",
        "mapsURL": "https://maps.app.goo.gl/4LoFRyUHsmDMFyao7"
      }
    ]
  },
  "Drnehaaroraverma1984@gmail.com": {
    "logo": "NamohLogo",
    "footer": "Powered by NEMA AI in partnership with Shree Namoh Wellness",
    "website": "https://drnehaarora.com/",
    "email": "Drnehaaroraverma1984@gmail.com",
    "phone": [
      "9827079888"
    ],
    "address": [
      {
        "city": "Indore",
        "mapsURL": "https://maps.app.goo.gl/8EpVR5kshaw1M8Hx6"
      }
    ]
  },
  "HPC@gmail.com": {
    "logo": "HPCLogo",
    "footer": "Powered by NEMA AI in partnership with HPC",
    "website": "https://www.holisticpsychotherapy.sg/",
    "email": "enquiry@holisticpsychotherapy.sg",
    "phone": [
      "+65 66318446"
    ],
    "address": [
      {
        "city": "Singapore",
        "mapsURL": "https://maps.app.goo.gl/qHXpBnxs65UH4utQ7"
      }
    ]
  },
  "rosh.aryiz@gmail.com": {
    "logo": "",
    "footer": "Powered by NEMA AI in partnership with Aryiz AI",
    "website": "",
    "email": "rosh.aryiz@gmail.com",
    "phone": [
      "+61 468734384"
    ],
    "address": [
      {
        "city": "Australia",
        "mapsURL": "https://maps.app.goo.gl/cBmiRN6JTjnrL5sZ7"
      }
    ]
  },
  "foundationreforminglives@gmail.com": {
    "logo": "https://s3.ap-south-1.amazonaws.com/nemaai.com/rohinidrsubodh.png",
    "footer": "Powered by NEMA AI in partnership with Reforming Lives",
    "website": "https://reforminglives.in/",
    "email": "reforminglivesfoundation@gmail.com",
    "phone": [
      "+91-8130405040"
    ],
    "address": [
      {
        "city": "Rohini Delhi",
        "mapsURL": "https://maps.app.goo.gl/yGBpXw7hNPDaJF3H7"
      }
    ]
  }
}
export default clientConfig
